import { FormContext } from './useFormContext';

const useAmountValidation = (
  context: FormContext,
  balance: number,
  amount: number,
  vendorAmount: number,
  minTnx: number,
  maxTnx: number
): [boolean, boolean, boolean, boolean, boolean] => {
  const { isDeposit } = context;

  const isMinTnxViolated = vendorAmount < minTnx;
  const isMaxTnxViolated = vendorAmount > maxTnx;
  const isBalanceViolated = !isDeposit && amount > balance;

  const isAmountInLimits = !isMinTnxViolated && !isMaxTnxViolated && !isBalanceViolated;

  const isAmountValid = amount > 0 && vendorAmount > 0 && isAmountInLimits;

  return [isMinTnxViolated, isMaxTnxViolated, isBalanceViolated, isAmountInLimits, isAmountValid];
};

export default useAmountValidation;
